import React from 'react';
import { HelpCircle, Mail, MessageCircle } from 'lucide-react';

const Help = () => {
    return (
        <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
                <h1 className="text-3xl font-bold text-slate-900 mb-4">How can we help you?</h1>
                <p className="text-slate-500">Search our knowledge base or contact our AI support agents.</p>
                <div className="mt-6 max-w-lg mx-auto relative">
                    <input type="text" placeholder="Search for answers..." className="input pl-10" />
                    <HelpCircle className="absolute left-3 top-3 text-slate-400" size={20} />
                </div>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mb-12">
                <div className="bg-white p-6 rounded-xl border border-slate-200 text-center">
                    <div className="w-12 h-12 bg-indigo-50 text-primary rounded-full flex items-center justify-center mx-auto mb-4"><MessageCircle /></div>
                    <h3 className="font-bold mb-2">Chat Support</h3>
                    <p className="text-sm text-slate-500 mb-4">Talk to our AI agents instantly.</p>
                    <button className="btn btn-secondary w-full">Start Chat</button>
                </div>
                <div className="bg-white p-6 rounded-xl border border-slate-200 text-center">
                    <div className="w-12 h-12 bg-indigo-50 text-primary rounded-full flex items-center justify-center mx-auto mb-4"><Mail /></div>
                    <h3 className="font-bold mb-2">Email Us</h3>
                    <p className="text-sm text-slate-500 mb-4">Get a response within 24 hours.</p>
                    <button className="btn btn-secondary w-full">Send Email</button>
                </div>
                <div className="bg-white p-6 rounded-xl border border-slate-200 text-center">
                    <div className="w-12 h-12 bg-indigo-50 text-primary rounded-full flex items-center justify-center mx-auto mb-4"><HelpCircle /></div>
                    <h3 className="font-bold mb-2">Documentation</h3>
                    <p className="text-sm text-slate-500 mb-4">Read guides and tutorials.</p>
                    <button className="btn btn-secondary w-full">View Docs</button>
                </div>
            </div>

            <div className="space-y-4">
                <h2 className="text-xl font-bold text-slate-900">Frequently Asked Questions</h2>
                {[
                    { q: "How does AutoInventor generate businesses?", a: "We use advanced LLMs combined with real-time market APIs to analyze demand, competition, and financial viability." },
                    { q: "Is the generated code production ready?", a: "The MVP code is designed to be a starting point. It is fully functional but we recommend review before scaling to millions of users." },
                    { q: "How much does it cost?", a: "AutoInventor is free to try. We charge a small platform fee only when your AI-generated business makes its first dollar." }
                ].map((faq, i) => (
                    <div key={i} className="bg-white border border-slate-200 p-6 rounded-lg">
                        <h4 className="font-bold text-slate-900 mb-2">{faq.q}</h4>
                        <p className="text-slate-500">{faq.a}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Help;
